export default {
  COMMON: 'e-office',
  LANGUAGE: 'e-office:language',
  ROLES: 'e-office:roles',
  DYNAMIC: 'e-office:dynamic',
  SUBSCRIPTION: 'e-office:subscription',
  ACCESS_TOKEN: 'e-office:accessToken',
  REFRESH_TOKEN: 'e-office:refreshToken',
};
